import styled from '@emotion/styled'
import { FunctionComponent, ReactNode } from 'react'
import { Color, Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { EditPageWrapper } from '~/components/_styled/page'
import Button from '~/components/Button'
import { ContentCard } from '~/components/ContentCard'
import { Link } from '~/components/Link'
import { WithClassName } from '~/types/utils'

const TitleBar = styled.div`
  display: flex;
  padding-bottom: 40px;
  width: 100%;
  justify-content: space-between;
  h1 {
    ${Fonts.H1}
  }
  ${Link} {
    margin-bottom: 12px;
  }
`

const AdmEditContentCard = styled(ContentCard)`
  width: 1000px;
`

const BottomBar = styled.div`
  border-top: 1px solid ${Colors.Platinum};
`

const Title = styled.div`
  ${Fonts.H1}
  padding-bottom: 20px;
  font-weight: regular;
`

export type PureAdmEditPageProps = WithClassName & {
  children: ReactNode | ReactNode[]
  onBackClick: () => void
  breadcrumbs: ReactNode
  color: Color
  title: ReactNode
}

const UnstyledPureAdmEditPage: FunctionComponent<PureAdmEditPageProps> = ({ children, onBackClick, breadcrumbs, color, title }) => {
  return (
    <EditPageWrapper>
      <TitleBar>
        {breadcrumbs}
        <Button variant={'tertiary'} onClick={onBackClick} trackingLabel={'adm-forms-back'}>
          Back
        </Button>
      </TitleBar>
      <AdmEditContentCard color={color}>
        <Title>{title}</Title>
        <BottomBar />
        {children}
      </AdmEditContentCard>
    </EditPageWrapper>
  )
}

// TODO 2024-07-19 SLE, NRA: This template page is not dedicated to stack only
export const PureAdmEditPage = styled(UnstyledPureAdmEditPage)``
